import { useGetList, type Identifier } from "ra-core";

import type { DealDelivery } from "../types";

/** Delivery summary of every deal, fetched once and shared (Kanban cards, dashboard). */
export const useDeliveries = () =>
  useGetList<DealDelivery>(
    "deals_delivery",
    {
      pagination: { page: 1, perPage: 1000 },
      sort: { field: "id", order: "ASC" },
    },
    { staleTime: 30 * 1000 },
  );

export const useDealDelivery = (dealId?: Identifier) => {
  const { data, ...rest } = useDeliveries();
  return {
    delivery: data?.find((d) => String(d.id) === String(dealId)),
    ...rest,
  };
};

export type DeliveryHealth = "on_track" | "at_risk" | "late";

export const deliveryHealth = (delivery?: DealDelivery): DeliveryHealth => {
  if (!delivery) return "on_track";
  if (delivery.nb_overdue > 0) return "late";
  if (delivery.next_due_date) {
    const days =
      (new Date(`${delivery.next_due_date}T00:00:00`).getTime() - Date.now()) /
      86400000;
    if (days <= 7 && delivery.progress < 100) return "at_risk";
  }
  return "on_track";
};

export const HEALTH_COLORS: Record<DeliveryHealth, string> = {
  on_track: "#22c55e",
  at_risk: "#f59e0b",
  late: "#ef4444",
};
